<template>
    <div class="logout_pop">
       <div class="content">
            确认解绑支付宝账号?
       </div> 
       <div class="btns">
        <el-button class="btn_cancel" plain round @click="closeModal">取消</el-button>
        <el-button class="btn_confirm" round type="primary" @click="onSuccess">确认解绑</el-button>
       </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        onSuccess() {
            this.$emit('success')
        }
    },
}
</script>
<style lang="less" scoped>
    .logout_pop {
        padding: 3.4rem 2.5rem;
        .content {
            text-align: center;
            font-size: 1.6rem;
            color: #555;
            margin-bottom: 2.5rem;
        }
        .btns {
            display: flex;
            justify-content: space-around;
            align-items: center;
            .el-button {
                width: 10.8rem;
                height: 3.2rem;
                font-size: 1.6rem;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                border: none;
                &:active {
                    opacity: 0.8;
                }
            }
            .btn_cancel {
                background-color: #E9E9E9;
                color: #606060;
            }
        }
    }
</style>